import { createFileRoute } from '@tanstack/react-router'
import { NewsletterPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/newsletter')({
  head: () => staticRouteHead('newsletter', 'de'),
  component: NewsletterPage,
})
